import { mathFormat } from '@/pages/intelligence/utils/commonUtils';
import * as echarts from 'echarts';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';

export default function SentimentChart(props: any) {
  const {mentionsList} = props
  const ref = useRef<HTMLDivElement>(null);

  const echartsFormatter = (params, option) => {
    let gameName: any
    let total: any
    let resultTooltip
    const paramsLength = params?.length;
    const index2 = paramsLength - 2;
    if (params.length > 0) {
      total = mentionsList[params[0]?.dataIndex]?.mention
      gameName = params[0]?.axisValue;
    }

    resultTooltip = `
      <div style="margin-left:2px;margin-right:2px;">
        <span style="color:rgba(0,0,0,0.45);font-size:12px;word-break:break-word;white-space: normal;">${gameName}</span></br>
        ${option !== 'sdauOption' ? `
        `: ''}
      </div>
      `
    // 三种情感
    if (option === 'option' || option === 'mdauOption') {
      for (let index = 0; option === 'option' ? index < paramsLength : index < index2; index++) {
        const element = params[index]
        element.axisValue
        let indexColor = element.color
        let name: any = ''
        let rate: any = ''
        let value: any = ''
        const metionIndex = mentionsList?.findIndex((v, i) => v.time === element.axisValue)
        switch (element.seriesName) {
          case 'Sentiment':
            name = 'Sentiment'
            value = mentionsList[metionIndex]?.sentiment_avg
            break
          case 'Positive':
            name = 'Positive'
            rate = mentionsList[metionIndex]?.positive_mention_rate
            value = mentionsList[metionIndex]?.positive_mention
            break
          case 'Neutral':
            name = 'Neutral'
            rate = mentionsList[metionIndex]?.neutral_mention_rate
            value = mentionsList[metionIndex]?.neutral_mention
            break
          case 'Negative':
            name = 'Negative'
            rate = mentionsList[metionIndex]?.negative_mention_rate
            value = mentionsList[metionIndex]?.negative_mention
            break
        }
        resultTooltip += element.seriesName === 'total总数' ? '' : `
          <div style="display:flex;justify-content: space-between;margin-left:2px;margin-right:2px;">
            <div style="color:rgba(0,0,0,0.65);font-size:12px;display:flex; align-items:center;margin-right:20px;">
              <span style="width:9px;height:9px;border-radius:10px;background:${indexColor};"></span>
              <span style="color:rgba(0,0,0,0.65);margin-left:5px;font-size:12px">${name}</span>
            </div>
            <div style="text-align: right;">
              <span style="font-weight: 600;color: #000;margin-left:20px;font-size:12px">
                ${name == 'Sentiment' ? value : mathFormat(value)}${rate ? '(' + Math.round(rate * 100) + '%)' : ''}
              </span>
            </div>
          </div>
          `
      }
    }

    return resultTooltip
  }

  const getData = (type: string) => {
    const avg: any = []
    const negative: any = []
    const neutraul: any = []
    const positive: any = []
    const time: any = []
    let total: any = []
    const offsetWidth: number = ref?.current?.offsetWidth;
    mentionsList.map((item) => {
      avg.push(item.sentiment_avg === '' ? '0.00' : item.sentiment_avg)
      negative.push(item.negative_mention_rate)
      neutraul.push(item.neutral_mention_rate)
      positive.push(item.positive_mention_rate)
      time.push(item.time)
    })
    if ((offsetWidth <= 636 && mentionsList.length > 10) || mentionsList.length > 16) {
      total = []
    } else {
      total = mentionsList.map((m: any) => m?.mention)
    }
    const returnData: {
      [type: string]: []
    } = {
      "xAxis": time,
      "total": total,
      "avg": avg,
      "negative": negative,
      "neutraul": neutraul,
      "positive": positive
    }
    return returnData[type] || []
  }

  const getOptions = () => {
    return {
      color: ["#376AE7",],
      tooltip: {
        padding: [6, 12],
        trigger: 'axis',
        formatter: (params) => echartsFormatter(params, 'option'),
        backgroundColor: 'rgba(0,0,0,0)'
      },
      grid: {
        top: '20px',
        left: '0',
        right: '0',
        bottom: '0',
        containLabel: true,
      },
      legend: {
        data: ['Sentiment', 'Positive', 'Neutral', 'Negative'],
        bottom: 0,
        textStyle: {
          color: '#888888',
          fontWeight: 400,
          fontSize: '12px',
        },
        itemGap: 20,
        icon: 'circle',
        itemWidth: 8,
        itemHeight: 8,
      },
      xAxis: [
        {
          boundaryGap: true,
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: '#000000',
              opacity: '0.25',
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.25)'
            }
          },
          axisLabel: {
            color: '#000000',
            opacity: '0.45',
            interval: 0,
            rotate: 35,
            showMaxLabel: true,
            width: 80,
            overflow: "break",
            align: "center",
            margin: 30,
          },
          type: 'category',
          data: getData("xAxis"),
          axisPointer: {
            type: 'shadow',
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          splitLine: { show: false },
          axisLabel: {
            formatter: (value) => {
              if (value === 0) {
                return 0
              }
              return `${value * 100}%`
            },
            color: '#000000',
            opacity: '0.45',
          },
          nameTextStyle: {
            color: '#444444',
            fontWeight: 400,
            fontSize: '12px',
          },
          splitNumber: 5,
        },
        {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: '#000000',
            opacity: '0.45',
          },
          max: 5,
          min: 0,
          splitNumber: 5,
        },
      ],
      series: [
        {
          name: 'Sentiment',
          type: 'line',
          yAxisIndex: 1,
          lineStyle: {
            color: '#5086F3',
          },
          // symbol: 'image//',
          data: getData("avg"),
        },
        {
          name: 'total总数',
          type: 'bar',
          barMaxWidth: '70px', // 柱子宽度同实体柱子，否则会错位
          barGap: '-100%', // 左移100%，stack不再与需堆叠的柱子在一列
          label: {
            normal: {
              show: true,
              position: 'top', // 位置设为top
              formatter: c => mathFormat(c?.value),
              textStyle: { color: '#444' },
            }
          },
          itemStyle: {
            normal: {
              color: 'rgba(128, 128, 128, 0)', // 为透明
            }
          },
          data: getData("total"),
          barWidth: 30,//柱状图宽度
        },
        {
          name: 'Positive',
          type: 'bar',
          stack: '1',
          yAxisIndex: 0,
          data: getData("positive"),
          itemStyle: {
            color: '#4FCB87',
          },
          barMaxWidth: '70px',
          barWidth: 30,//柱状图宽度
        },
        {
          name: 'Neutral',
          type: 'bar',
          stack: '1',
          yAxisIndex: 0,
          data: getData("neutraul"),
          itemStyle: {
            color: '#7E92A1',
          },
          barMaxWidth: '70px',
          barWidth: 30,//柱状图宽度
        },
        {
          name: 'Negative',
          type: 'bar',
          stack: '1',
          yAxisIndex: 0,
          data: getData("negative"),
          itemStyle: {
            color: '#E95F6A',
          },
          barMaxWidth: '70px',
          barWidth: 30,//柱状图宽度
        },
      ],
    }
  }

  const handleResize = (chart) => {
    if (ref?.current) {
      chart.resize();
    }
  };

  useEffect(() => {
    let _chart;
    let listener: null | (() => void) = null;

    if (ref.current) {
      const options = getOptions();
      // canvas
      _chart = echarts.init(ref.current, undefined, { renderer: 'canvas' });
      _chart.setOption(options, { notMerge: true });
      listener = () => {
        handleResize(_chart);
      };

      window.addEventListener('resize', listener);
    }

    return () => {
      if (_chart && listener !== null) {
        window.removeEventListener('resize', listener);
        _chart.off();
      }
    };
  }, [props]);

  const chartStyle = {
    height: '350px',
    width: '100%',
  };

  return (
    <div style={{ ...chartStyle, textAlign: 'center' }}>
      <div ref={ref} style={chartStyle}></div>
    </div>
  );
}